import * as types from './types';

export const bulkInviteRequest = (data) => ({ type: types.BULK_INVITE_REQUEST, data });
export const bulkInviteRequestFailure = (error) => ({ type: types.BULK_INVITE_REQUEST_FAILURE, error });
export const bulkInviteRequestSuccess = (data) => ({ type: types.BULK_INVITE_REQUEST_SUCCESS, data });

export const getTeamRequest = (data) => ({ type: types.GET_TEAM_REQUEST, data });
export const getTeamRequestFailure = (error) => ({ type: types.GET_TEAM_REQUEST_FAILURE, error });
export const getTeamRequestSuccess = (data) => ({ type: types.GET_TEAM_REQUEST_SUCCESS, data });

export const inviteUserRequest = (data) => ({ type: types.INVITE_USER_REQUEST, data });
export const inviteUserRequestFailure = (error) => ({ type: types.INVITE_USER_REQUEST_FAILURE, error });
export const inviteUserRequestSuccess = (data) => ({ type: types.INVITE_USER_REQUEST_SUCCESS, data });
